import type { SkinManifest } from '@/shared/theme/orange-sports-skin';

const skinRoot = '/skins/lor-us-h5';
const host = `${skinRoot}/www.lordofriches.com`;
const cdn = `${skinRoot}/cdn.lordofriches.com`;

/** Lord of Riches US H5：素材/样式自 https://www.lordofriches.com 抓取，与 gc987-h5 完全独立。 */
export const lorUsH5Skin: SkinManifest = {
  assets: {
    avatar: `${host}/static/image/americanAvatar/18.png`,
    chests: {
      claimable: `${host}/assets/new-customer-53b2a06d.png`,
      locked: `${host}/assets/new-customer-53b2a06d.png`,
      opened: `${host}/assets/new-customer-53b2a06d.png`,
    },
    hero: `${cdn}/uploads/20260328/e2641c760cc42ddbf9c1f81ede1d6eb9.png`,
    logo: `${skinRoot}/brand/logo.png`,
    pixQr: `${skinRoot}/brand/favicon.png`,
  },
  brandName: 'Lord of Riches',
  campaigns: [
    {
      accent: 'blue',
      artworkOnly: true,
      cta: 'Deposit',
      eyebrow: 'Bonus',
      image: `${cdn}/uploads/20260328/e2641c760cc42ddbf9c1f81ede1d6eb9.png`,
      key: 'banner-1',
      reward: '',
      subtitle: '',
      title: 'First Deposit +270%',
      to: '/deposit',
    },
    {
      accent: 'blue',
      artworkOnly: true,
      cta: 'Play',
      eyebrow: 'Promo',
      image: `${cdn}/uploads/20260320/cec4952c0dc67c4e1748f3bd0869faa7.png`,
      key: 'banner-2',
      reward: '',
      subtitle: '',
      title: 'Daily Bonus',
      to: '/promotions',
    },
    {
      accent: 'gold',
      artworkOnly: true,
      cta: 'Claim',
      eyebrow: 'Bonus',
      image: `${cdn}/uploads/20260328/e7d1ed7b1934c5421201010a4e849792.png`,
      key: 'banner-3',
      reward: '',
      subtitle: '',
      title: 'Limited Time',
      to: '/promotions',
    },
  ],
  categories: [
    {
      active: true,
      image: `${cdn}/uploads/20250623/796e8e6d0a8462191e252fa998984395.png`,
      label: 'Popular',
      subtitle: 'Hot',
      type: 'popular',
    },
    {
      image: `${cdn}/uploads/20250623/b3a85da8c1e2831fe992705ba4d415ff.png`,
      label: 'PG',
      subtitle: 'PG Soft',
      type: 'pg',
    },
    {
      image: `${cdn}/uploads/20250623/951aaa114a85dd00d158cac84bc96b6b.png`,
      label: 'TADA',
      subtitle: 'TADA',
      type: 'tada',
    },
    {
      image: `${cdn}/uploads/20250623/1b2b3ace4a6c1a2a47fc8e09d1a0b2e4.png`,
      label: 'Pragmatic',
      subtitle: 'PP',
      type: 'pragmatic',
    },
  ],
  code: 'lor-us-h5',
  games: [],
};

export const lorUsThemeTokenUrl = `${skinRoot}/theme-tokens.json`;

export const lorUsNavAssets = {
  bonus: `${skinRoot}/nav/tabbar-bonus.png`,
  bonusActive: `${skinRoot}/nav/tabbar-bonus-active.png`,
  deposit: `${skinRoot}/nav/tabbar-deposit.png`,
  depositActive: `${skinRoot}/nav/tabbar-deposit-active.png`,
  play: `${skinRoot}/nav/tabbar-play.png`,
  playActive: `${skinRoot}/nav/tabbar-play-active.png`,
  promotion: `${skinRoot}/nav/tabbar-promotion.png`,
  promotionActive: `${skinRoot}/nav/tabbar-promotion-active.png`,
  share: `${skinRoot}/nav/tabbar-share.png`,
  shareActive: `${skinRoot}/nav/tabbar-share-active.png`,
} as const;

export const lorUsAssetPaths = {
  avatar: `${host}/static/image/americanAvatar/18.png`,
  /** 源站 `.home-head-addIcon-float` 背景（data:webp 落地） */
  bonusFloat: `${skinRoot}/icons/bonus-float.webp`,
  collection: `${host}/static/image/americanPublic/collection_m1.svg`,
  cooperate1: `${host}/assets/cooperate1-eb71ff41.webp`,
  cooperate2: `${host}/assets/cooperate2-4c1d0261.webp`,
  cooperate3: `${host}/assets/cooperate3-64d2bde9.webp`,
  gameArrow: `${host}/static/image/americanPublic/game_arrow_white.svg`,
  logo: `${skinRoot}/brand/logo.png`,
  /** 源站 sortgame 左侧分类未选/选中底图 */
  moreTypeActive: `${skinRoot}/games/more-type-active.png`,
  moreTypeIdle: `${skinRoot}/games/more-type-idle.png`,
  moreArrow: `${host}/static/image/public/0205_sanjiao_bai.png`,
  rechargeAdd: `${skinRoot}/icons/recharge-add.webp`,
  searchIcon: `${host}/static/image/easy-loadimage/easy-game.png`,
  sideFloat: `${host}/static/image/americanPublic/a2-left.webp`,
  /** 源站 footer `.afooter-share-img` data:webp 落地 */
  socials: [
    `${skinRoot}/icons/social-1.webp`,
    `${skinRoot}/icons/social-2.webp`,
    `${skinRoot}/icons/social-3.webp`,
    `${skinRoot}/icons/social-4.webp`,
    `${skinRoot}/icons/social-5.webp`,
  ] as const,
  /** 源站 `.home-float-adBox` 展开广告（cdn 落地） */
  floatAds: [
    `${skinRoot}/float-ads/ad-1.webp`,
    `${skinRoot}/float-ads/ad-2.webp`,
    `${skinRoot}/float-ads/ad-3.webp`,
    `${skinRoot}/float-ads/ad-4.webp`,
    `${skinRoot}/float-ads/ad-5.webp`,
    `${skinRoot}/float-ads/ad-6.webp`,
    `${skinRoot}/float-ads/ad-7.webp`,
  ] as const,
  vipIcon: `${host}/static/image/person/vip_icon00.webp`,
  welcomeBg: `${skinRoot}/welcome/americanBg3.png`,
  /** 源站 signIn 每日签到弹层（Daily Bonus）：banner 用镜像 assets，coin/close 为内联 data 落地 */
  signIn: {
    banner: `${host}/assets/daily-title-6f0d7139.webp`,
    coin: `${skinRoot}/signin/coin.webp`,
    close: `${skinRoot}/signin/close.png`,
  },
  /** 源站 firstCharge 首充弹层（First Deposit）：banner 为 cdn 龙+迪斯科球图（左侧透明，露 teal 底） */
  firstCharge: {
    banner: `${cdn}/uploads/20260320/612f9d368dda0ea2684fac5e9751ecf1.webp`,
  },
  /** 源站 binding-a1 绑定手机弹层（Bind/Link）：banner 含文案+手机图，phone 为输入框右侧图标 */
  bind: {
    banner: `${skinRoot}/bind/banner.png`,
    phone: `${skinRoot}/bind/phone.png`,
  },
  /** 源站 activityBonus 四卡整图（含 3D 图标区） */
  bonus: {
    bind: `${skinRoot}/bonus/bind.webp`,
    daily: `${skinRoot}/bonus/daily.webp`,
    download: `${skinRoot}/bonus/download.webp`,
    rescue: `${skinRoot}/bonus/rescue.webp`,
  },
  /** 源站 servicePop-a3 客服弹层（Customer Service）：header 头图（左透明露暗底），telegram/facebook 按钮图标 */
  service: {
    header: `${skinRoot}/service/header.webp`,
    telegram: `${skinRoot}/service/telegram.png`,
    facebook: `${skinRoot}/service/facebook.png`,
  },
  /** 源站 turntable-pop 转盘弹窗（Share to win $40）：lottery-bg 大背景(REFERRAL/外框/缎带/logo)，wheel 扇区，pointer 指针 */
  share: {
    bg: `${skinRoot}/share/lottery-bg.webp`,
    wheel: `${skinRoot}/share/wheel.png`,
    pointer: `${skinRoot}/share/pointer.png`,
    /** 源站 pages/activity/share `.a2-shareHeadBg` */
    pageHeadBg: `${skinRoot}/share/bg-new.webp`,
    /** 源站 `.a2-shareHead-moneyBg` 金额底图 */
    pageMoneyBg: `${skinRoot}/share/mount-bg.webp`,
  },
  /** 源站 turntableAward 转奖结果弹窗（Get Free Withdrawal Access） */
  award: {
    headMoney: `${skinRoot}/award/head-money.webp`,
    close: `${skinRoot}/award/close.png`,
    avatars: [
      `${skinRoot}/award/avatar-7.png`,
      `${skinRoot}/award/avatar-12.png`,
      `${skinRoot}/award/avatar-15.png`,
      `${skinRoot}/award/avatar-19.png`,
      `${skinRoot}/award/avatar-20.png`,
    ],
  },
  /** 源站 +270% Deposit 整页（pages/recharge/firstDeposit）资源集 */
  firstDeposit270: {
    headBg: `${skinRoot}/firstdeposit270/head-bg.webp`,
    coinDollar: `${skinRoot}/firstdeposit270/coin-dollar.webp`,
    thumb: `${skinRoot}/firstdeposit270/thumb.png`,
    oneHand: `${skinRoot}/firstdeposit270/one-hand.png`,
    step1Img: `${skinRoot}/firstdeposit270/step-1-img.webp`,
    step1Gold: `${skinRoot}/firstdeposit270/step-1-gold.webp`,
    step2Img: `${skinRoot}/firstdeposit270/step-2-img.webp`,
    step3Img: `${skinRoot}/firstdeposit270/step-3-img.webp`,
    arrow: `${skinRoot}/firstdeposit270/arrow.png`,
    stepBg: `${skinRoot}/firstdeposit270/step-bg.webp`,
    login6Dice: `${skinRoot}/firstdeposit270/login6-dice.webp`,
  },
} as const;
